export default __webpack_public_path__ + "static/media/cp_geo_kz.64e40aca.svg";